const mainSectionsFooter={
    "/":"Головна",
    "/aboutUs":"Про нас",
    "/gallery":"Галерея",
    "/blog":"Блог"
}

export default mainSectionsFooter;